import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSmileySad = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(-4 -4)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h48v48H0z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 31,
				cy: 19,
				r: 3,
				fill: "#4BB678",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 19,
				r: 3,
				fill: "#4BB678",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M0 0h48v48H0z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 31,
				cy: 19,
				r: 3,
				fill: "#F4574C",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 19,
				r: 3,
				fill: "#F4574C",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F4574C",
				fillRule: "nonzero",
				d: "M23.98 4C12.94 4 4 12.96 4 24s8.94 20 19.98 20C35.04 44 44 35.04 44 24S35.04 4 23.98 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16zm0-12c4.66 0 8.64 2.9 10.24 7H30.9c-1.38-2.38-3.94-4-6.9-4-2.96 0-5.5 1.62-6.9 4h-3.34c1.6-4.1 5.58-7 10.24-7z"
			})
		]
	})
});
export default SvgSmileySad;
